import { apiCall, ApiConfig } from '../../config/api'
import { TypeInventoryIncident } from '../../interfaces/Configuration/Configuration'
import { getTypeInventoryIncidentAction } from '../actions/typeInventoryIncidentActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_INVENTORY_INCIDENT } from '../types/typeInventoryIncidentActionsTypes'

export function* getTypesInventoryIncidentAsync() {
  try {
    const { status, data }: AxiosResponse<TypeInventoryIncident[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeInventoryIncident}/Get`
    )
    if (status === 200) {
      yield put(getTypeInventoryIncidentAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeInventoryIncidentAction([], serverError.message))
  }
}

export function* watchGetTypesInventoryIncidentAsync() {
  yield takeEvery(GET_TYPE_INVENTORY_INCIDENT, getTypesInventoryIncidentAsync)
}
